import { ComponentCO2Link } from '@acies/domain';
import { ObservableCollection } from '@acies/observables';
import { InputFieldEvent } from '@acies/ui';
import CO2Model from '../models/co2-model';
import FilterComponentCO2LinkModel from '../models/filter-component-co2link.model';

export default class FilterComponentCO2LinkController {
	#co2LinkCollection: ObservableCollection<ComponentCO2Link>;
	#filterComponentCO2LinkModel: FilterComponentCO2LinkModel;
	public constructor(co2Model: CO2Model) {
		this.#co2LinkCollection = co2Model.listComponentCO2LinkModel.co2LinkCollection;
		this.#filterComponentCO2LinkModel = co2Model.filterComponentCO2LinkModel;
		this.#co2LinkCollection.subscribe(this.#collectionUpdated.bind(this));
	}

	/** We pass on the text value of the Event to the model that updates the filter. */
	public filterInputChanged(event: Event): void {
		if (event instanceof InputFieldEvent) {
			this.#filterComponentCO2LinkModel.filter = event.text;
			this.#filterComponentCO2LinkModel.filterInputText = event.text;
		}
	}

	/** If the co2LinkCollection doesn't contain any items, because it hasn't loaded yet, clear and disable the filter InputField, otherwise enable the InputField. */
	#collectionUpdated(): void {
		if (!this.#co2LinkCollection.containsUnfilteredItems) {
			this.#co2LinkCollection.filter = '';
			this.#filterComponentCO2LinkModel.filterInputText = '';
			this.#filterComponentCO2LinkModel.filterInputEnabled = false;
		} else {
			this.#filterComponentCO2LinkModel.filterInputEnabled = true;
		}
	}
}
